import React, { useState, useEffect } from 'react';

function ImageModal({ isOpen, onClose, imageSrc, imageAlt }) {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (isOpen) {
      setScale(1);
      setPosition({ x: 0, y: 0 });
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.1 : 0.1;
    setScale(prev => Math.max(0.5, Math.min(3, prev + delta)));
  };

  const handleMouseDown = (e) => {
    if (scale > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && scale > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleZoomIn = () => {
    setScale(prev => Math.min(3, prev + 0.2));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(0.5, prev - 0.2));
  };

  const handleReset = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  if (!isOpen) return null;

  return (
    <div 
      className="modal-overlay" 
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '80px 20px 80px 20px' // Add padding to prevent overlap
      }}
      onClick={onClose}
    >
      {/* Zoom Controls - Fixed to viewport */}
      <div style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        display: 'flex',
        gap: '0.5rem',
        zIndex: 2002,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '0.5rem',
        borderRadius: '8px',
        backdropFilter: 'blur(4px)'
      }}>
        <button 
          className="btn btn-secondary"
          onClick={handleZoomOut}
          style={{ 
            padding: '0.5rem', 
            fontSize: '0.875rem',
            minWidth: '32px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: '#1f2937'
          }}
          title="Zoom Out"
        >
          −
        </button>
        <button 
          className="btn btn-secondary"
          onClick={handleReset}
          style={{ 
            padding: '0.5rem', 
            fontSize: '0.875rem',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: '#1f2937'
          }}
          title="Reset Zoom"
        >
          ↻
        </button>
        <button 
          className="btn btn-secondary"
          onClick={handleZoomIn}
          style={{ 
            padding: '0.5rem', 
            fontSize: '0.875rem',
            minWidth: '32px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: '#1f2937'
          }}
          title="Zoom In"
        >
          +
        </button>
        <button 
          className="btn btn-danger"
          onClick={onClose}
          style={{ 
            padding: '0.5rem', 
            fontSize: '0.875rem',
            backgroundColor: 'rgba(239, 68, 68, 0.9)',
            color: 'white'
          }}
          title="Close"
        >
          ✕
        </button>
      </div>

      {/* Image Container */}
      <div 
        style={{
          position: 'relative',
          maxWidth: '100%',
          maxHeight: '100%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageSrc}
          alt={imageAlt || 'Zoomed image'}
          style={{
            transform: `scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`,
            cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'zoom-in',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            userSelect: 'none',
            zIndex: 1
          }}
          onWheel={handleWheel}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          draggable={false}
        />
      </div>

      {/* Instructions - Fixed to viewport */}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '0.75rem 1.5rem',
        borderRadius: '24px',
        fontSize: '0.875rem',
        textAlign: 'center',
        zIndex: 2002,
        backdropFilter: 'blur(4px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ fontWeight: '500' }}>
          🖱️ Scroll to zoom • 🤏 Drag to pan • ❌ Click outside to close
        </div>
      </div>
    </div>
  );
}

export default ImageModal; 